import React from 'react'
// import _ from 'lodash'

import MobilePortalSearch from './MobilePortalSearch'

const MobileHome = ({
  isAdmin,
  currentTown,
  towns,
  portals,
  onSelectTown,
  onSubmitPortal,
  onPortalDelete,
}) => (
  <div>
    {/* <div className="has-text-right">
      <div className="select is-fullwidth">
        <select name="town" onChange={onSelectTown} value={currentTown}>
          {_.map(towns, town => (
            <option key={town._id} value={town._id}>
              {_.isString(town.title) ? town.title : town.title.en}
            </option>
          ))}
        </select>
      </div>
    </div> */}

    <hr />

    <MobilePortalSearch
      isAdmin={isAdmin}
      portals={portals}
      onPortalSelect={onSubmitPortal}
      onPortalCreate={onSubmitPortal}
      onPortalDelete={onPortalDelete}
    />
  </div>
)

export default MobileHome



// WEBPACK FOOTER //
// ./src/components/templates/mobileHome/MobileHome.js